import React, { useState, useEffect } from 'react';
import { MDBSideNavCollapse, MDBSideNavItem, MDBSideNavLink, MDBIcon, MDBSelect } from 'mdb-react-ui-kit';
import { getAllSessions } from '../../../../utils/sessionsOperations';
import { createSessionSelectOptionsData } from './Utils';

const Session = ({ userSelectedSession, setUserSelectedSession }) => {
    const [collapse, setCollapse] = useState(false);
    const [sessions, setSessions] = useState([]);
    const [sessionSelectOptions, setSessionSelectOptions] = useState([]);

    useEffect(() => {
        const fetchSessions = async () => {
            try {
                const data = await getAllSessions();
                setSessions(data);
                setSessionSelectOptions(createSessionSelectOptionsData(data));
            } catch (error) {
                console.error('Error fetching sessions:', error);
            }
        };

        fetchSessions();
    }, []);

    const handleSessionChange = (value) => {
        setUserSelectedSession(value.value);
        setCollapse(false);
    };

    return (
        <MDBSideNavItem>
            <MDBSideNavLink icon='angle-down' shouldBeExpanded={collapse} onClick={() => setCollapse(!collapse)}>
                Session
            </MDBSideNavLink>
            <MDBSideNavCollapse open={collapse}>
                <div className="p-3">
                    <MDBSelect
                        data={sessionSelectOptions}
                        value={userSelectedSession}
                        onChange={(value) => handleSessionChange(value)}
                        search
                        label="Select Session"
                    />
                </div>
            </MDBSideNavCollapse>
        </MDBSideNavItem>
    );
};

export default Session;